module.exports = __webpack_public_path__ + "img/hero.3446a5c3.png";